module.exports = __webpack_public_path__ + "static/media/table.ccbe5c44.png";